import { FormField } from 'app/form-fields/common/register/form-field';

export class MultiLineInput extends FormField {
  constructor(item, header) {
    super(item, header);
    this.expandable = true;
  }
}
